import { render, staticRenderFns } from "./OrganizeCrime.vue?vue&type=template&id=436ea22e"
import script from "./OrganizeCrime.vue?vue&type=script&lang=js"
export * from "./OrganizeCrime.vue?vue&type=script&lang=js"
import style0 from "./OrganizeCrime.vue?vue&type=style&index=0&id=436ea22e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports